import Link from '@mui/material/Link'
import React from 'react'

export default function ILink ({ children, onClick }) {
  return (
    <Link
      onClick={onClick}
      sx={{ cursor: 'pointer', fontSize: 1, height: 'inherit' }}
    >
      {children}
    </Link>
  )
}
